import script from "./Record4ChSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./Record4ChSetting.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__